// src/presets/lara/progressbar/index.ts
var progressbar_default = {
  root: {
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    height: "1.5rem"
  },
  value: {
    background: "{primary.color}"
  },
  label: {
    color: "{primary.contrast.color}",
    fontSize: "0.875rem",
    fontWeight: "600"
  }
};
export { progressbar_default as default };
